module.exports = __webpack_public_path__ + "img/complete.d5a620af.png";